<template>
    <div>       
        <div class="page-btns-box">
			<el-alert type="warning" :closable="false">
				添加的数量不限制, 但只有前6个生效(小红书接口限制6个) <br>
				可以拖动排序, 可以添加(默认加到最下面),删除, 最终要点提交按钮才会生效<br>
				演出结束或者在小红书下架, 该演出会自动从列表中去除, 并自动按顺序提交6个<br>
				添加的演出, 只能是当前已在小红书上架, 且演出未结束的<br><br>
				<el-button v-if="$utils.have('/redBookletSort/add')" type="primary" icon="el-icon-plus"  @click="$refs.add.show()"
				    size="small">添加演出</el-button>
				<el-button v-if="$utils.have('/redBookletSort/submit')" type="primary" @click="canAction()"
				    size="small">提交到小红书</el-button>
			</el-alert>
        </div>
        <div class="page-list-box">
            <div v-if="dataList && dataList.length > 1" class="color-info">
			是否开启自定义排序 
				<el-radio-group v-model="data.isApply" @change="canAction()" class="ML10">
					<el-radio :label="1">开启</el-radio>
					<el-radio :label="0">关闭</el-radio>
				</el-radio-group>
			</div>
			<vuedraggable v-model="dataList" @change="updateSort" handle=".handle" >
			<el-table
                :data="dataList"
                border
                style="width: 100%;"
                v-loading="listLoading"
                size="mini"
                stripe
                row-key="id"
                class="sortable-table MT10"		
            >
				<el-table-column prop="sortNum" label="序号"></el-table-column>
                <el-table-column prop="activityId" label="演出ID"></el-table-column>
                <el-table-column prop="title" label="演出名称" min-width="250"></el-table-column>
				<el-table-column prop="saleAmount" label="小红书销售额"></el-table-column>
				<el-table-column prop="saleNum" label="小红书销量"></el-table-column>
				<el-table-column prop="updateTime" label="上架小红书时间"></el-table-column>
                <el-table-column fixed="right" label="操作">
                    <template slot-scope="scope">                        
                        <el-button
                            type="text"
                            size="small"
                            @click="del(scope.row.activityId)"
                            >删除</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
			</vuedraggable>
        </div>
        <add ref="add" @onUpdate="getDataList"></add>
    </div>
</template>
<script>
import Sortable from "sortablejs";
import Add from "./components/add.vue";
import vuedraggable from 'vuedraggable';
export default {
    components: { Add,vuedraggable },
    data() {
        return {
            data: null,
            dataList: [],                  
            listLoading: false,
           
        };
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;            
            this.$request({
                url: "/redBookletSort/list",
                method: "POST",
                
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.list || [];
                        this.drag();
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
		canAction(){
			this.$request({
				url: "/redBookletSort/submit",
				method: "POST",
				params:{
					isApply:this.data.isApply
				}
			})
				.then((res) => {
					const { state, msg } = res.data;
					if (state == 1) {
						this.$message.success("操作成功");
						this.getDataList()
					} else {
						this.$message.error(msg || "操作失败");
					}
				})
				.catch(() => {
					this.$message.error("请求错误");
				})
				
		},
       //拖拽排序
       drag(){
           this.$nextTick(() => {
               const el = document.querySelectorAll('.sortable-table > .el-table__body-wrapper > table > tbody')[0];
               Sortable.create(el, {
                   disabled: false, // 拖拽不可用? false 启用
                   ghostClass: 'sortable-ghost', //拖拽样式
                   animation: 150, // 拖拽延时，效果更好看
                   onEnd: (e) => { // 拖拽结束时的触发
                       let arr = [...this.dataList]; // 获取表数据
                       arr.splice(e.newIndex, 0, arr.splice(e.oldIndex, 1)[0]); // 数据处理，获取最新的表格数据
                       
                       this.$nextTick(function () {
                           const a1 = (this.dataList.map(a => a.activityId)).toString();
                           const a2 = (arr.map(a => a.activityId)).toString();
                           if(a1 != a2){
                               this.dataList = arr;							   
                               this.updateSort();
                           }
                       })
                   },
               });
           })
       },
	   //排序
	   updateSort(){		  
		   this.dataList.map( (item,index) => {
		       item.sort = index+1;
			   item.id = item.activityId
		   })
		   this.$request({
			   url: "/redBookletSort/sort",
			   method: "POST",
			    data: this.dataList,
		   }).then((res) => {
				   const { state, msg } = res.data;
				   if (state == 1 ) {
					   this.$message.success("操作成功");
					   this.getDataList();
				   } else {
					   this.$message.error(msg || "操作失败");
				   }
			   })
			   .catch(() => {
				   this.$message.error("操作错误");
			   })
				   
	   },
        //新增事件
        add() {
            this.$router.push({ path: "/promotion/shareActivity/add" });
        },
        //编辑事件
        edit(id) {
            this.$router.push({
                path: `/promotion/shareActivity/edit/${id}`,
                query: {
                    v: this.$utils.uuid(),
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        this.params
                    ),
                },
            });
        },        
        //删除
        del(id) {
            const _msg = "确定要删除吗?";
            this.$confirm(_msg, "提示", {
                type: "warning",
                center: true,
                closeOnClickModal: false
            }).then(() => {
                this.listLoading = true;
                this.$request({
                    url: "/redBookletSort/delete",
                    method: "POST",
                    params: { activityId: id },
                })
                    .then((res) => {
                        const { state, msg } = res.data;
                        if (state == 1) {
                            this.getDataList();
                        } else {
                            this.$message.error(msg || "请求失败");
                        }
                    })
                    .catch(() => {
                        this.$message.error("请求错误");
                    })
                    .finally(() => {
                        this.listLoading = false;
                    });
            });
        }        
    },
};
</script>